import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DateTimeWithZone } from '../../common/date-time-with-zone.class';

@Injectable({
  providedIn: 'root'
})

export class TrainingTypeService {
  private trainingTypeSubject = new Subject<any>();
  private trainingTypeValidToSubject = new Subject<any>();
  setSelectedTrainingTypeId(trainingTypeId: string) {
    this.trainingTypeSubject.next(trainingTypeId);
  }
  getSelectedTrainingTypeId(): Observable<string> {
    return this.trainingTypeSubject.asObservable();
  }

  clearSelectedTrainingTypeId() {
    this.trainingTypeSubject.next(false);
  }

  setSelectedTrainingTypeValidTo(validTo: DateTimeWithZone) {
    this.trainingTypeValidToSubject.next(validTo);
  }

  getSelectedTrainingTypeValidTo(): Observable<DateTimeWithZone> {
    return this.trainingTypeValidToSubject.asObservable();
  }

  clearSelectedTrainingTypeValidTo() {
    this.trainingTypeValidToSubject.next(false);
  }
}
